import styled from 'styled-components';

export const Container = styled.div<{ $clickable?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;

    &:hover {
      background-color: #f0f0f0;
    }
  `}
`;

export const Label = styled.span`
  font-size: 14px;
  color: #333;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;

  h2 {
    margin-bottom: 0;
  }
  
  .icons{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 8px;

    button{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
`;